import { Dispatch } from 'redux'

import api from 'common/api'

import { MessagingState, MessagingTypes } from '.'

interface Message {
  // unknown until need
  Read: boolean
}
interface Discussion {
  // unknown until need
  Messages: Message[]
}

const populateUnreadMessageFlag = () => (dispatch: Dispatch<any>) => {
  api.get('/api/discussions?search=unread').then((discussions) => {
    const entriesWithNewMessages = (discussions as Discussion[]).filter((entry: Discussion) => {
      return entry.Messages.some((message: Message) => message.Read === false)
    })
    const numberOfEntriesWithNewMessages = entriesWithNewMessages.length

    dispatch(
      updateUnreadMessageFlag({
        unreadMessageCount: numberOfEntriesWithNewMessages,
      }),
    )
  })
}

const removeUnreadMessageFlag = () =>
  updateUnreadMessageFlag({
    hasUnreadMessage: false,
  })
const turnOnUnreadMessageFlag = () =>
  updateUnreadMessageFlag({
    hasUnreadMessage: true,
  })

const updateUnreadMessageFlag = (newValue: MessagingState) => {
  return {
    type: MessagingTypes.UPDATE_HAS_UNREAD_MESSAGE,
    payload: newValue,
  }
}

const actions = {
  populateUnreadMessageFlag,
  removeUnreadMessageFlag,
  turnOnUnreadMessageFlag,
  updateUnreadMessageFlag,
}

export default actions
